/* Mon Chou UI behaviors — "3.21" (Claude, 2026-09-07; select-then-redirect flow
   added the same day at Jonas's request). Loaded site-wide from
   snippets/mc-cart.liquid, defer.

   Backside-engraving upsell on the product page
   ---------------------------------------------
   snippets/adev-pairs-with-products.liquid always renders the block (marked
   [data-mc-pwp-pdp]). Before the parent necklace is in the cart, pressing the
   card SELECTS backside engraving (visual state via .mc-pwp-selected in
   mc-ui.css, explainer note revealed) instead of quick-adding — the quick-add
   would put an engraving product with no engraving text in the cart. When the
   parent necklace is then added to the cart, the shopper is taken straight to
   the backside product's page to customize that engraving too. A second press
   before add-to-cart deselects.

   How the add-to-cart is detected: assets/adev-pairs-with-products.min.js
   hides EVERY pairs block on its cart events and re-shows the in-cart ones,
   so any style mutation on the block means "the cart just changed". The
   MutationObserver below re-pins the block visible and reads /cart.js for
   the truth; a false→true parent-in-cart transition on a selected block
   means the necklace was just added, and the shopper is redirected. (The
   style VALUE cannot be trusted for the decision: this theme's jQuery 1.x
   .show() restores display to '', identical to our own reset.)

   sessionStorage carries the selection across the personalizer's rare
   full-page add-to-cart fallback (fetch is the normal path); a stored intent
   is honored only for the same parent product and only within 10 minutes. */
(function () {
    'use strict';

    var INTENT_KEY = 'mc_backside_intent';
    var INTENT_TTL = 10 * 60 * 1000;

    function noteEl(block) { return block.querySelector('.mc-pwp-note'); }

    function showNote(block) {
        var n = noteEl(block);
        if (n && n.hidden) {
            n.hidden = false;
            requestAnimationFrame(function () { n.classList.add('mc-note-open'); });
        }
    }

    function hideNote(block) {
        var n = noteEl(block);
        if (n) { n.hidden = true; n.classList.remove('mc-note-open'); }
    }

    function backsideUrl(block) {
        var a = block.querySelector('.adev-pwp__item:not(.adev-pwp__already-in-cart) .adev-pwp__item-link');
        return a ? a.getAttribute('href') : null;
    }

    function readIntent() {
        try { return JSON.parse(sessionStorage.getItem(INTENT_KEY) || 'null'); } catch (e) { return null; }
    }

    function clearIntent() {
        try { sessionStorage.removeItem(INTENT_KEY); } catch (e) {}
    }

    function setSelected(block, on) {
        block.classList.toggle('mc-pwp-selected', on);
        block.dataset.mcBacksideSelected = on ? 'true' : 'false';
        if (on) {
            showNote(block);
            try {
                sessionStorage.setItem(INTENT_KEY, JSON.stringify({
                    url: backsideUrl(block),
                    parent: block.getAttribute('data-adev-pairs-with-products'),
                    ts: Date.now()
                }));
            } catch (e) {}
        } else {
            hideNote(block);
            clearIntent();
        }
    }

    function goToBackside(block) {
        var intent = readIntent();
        var url = backsideUrl(block) || (intent && intent.url);
        clearIntent();
        if (url) window.location.assign(url);
    }

    function init() {
        var blocks = document.querySelectorAll('[data-mc-pwp-pdp]');

        /* The personalizer's rare native-submit fallback does a full-page
           add-to-cart and Shopify lands on /cart — a page with no pairs
           block. Honor a fresh selection wherever we come back up: on a page
           with the block if the parent is in the cart, otherwise by checking
           the cart directly. Consumed (or dropped when stale) either way, so
           it can never fire twice. */
        var intent = readIntent();
        if (intent && intent.url && Date.now() - (intent.ts || 0) < INTENT_TTL) {
            if (blocks.length) {
                blocks.forEach(function (b) {
                    if (b.dataset.mcParentInCart === 'true' &&
                        intent.parent === b.getAttribute('data-adev-pairs-with-products')) {
                        goToBackside(b);
                    }
                });
            } else {
                fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
                    var inCart = (c.items || []).some(function (it) {
                        return String(it.product_id) === String(intent.parent);
                    });
                    if (inCart) {
                        clearIntent();
                        window.location.assign(intent.url);
                    }
                }).catch(function () {});
            }
        } else if (intent) {
            clearIntent();
        }

        if (!blocks.length) return;

        /* adev-pairs-with-products.min.js hides every block and re-shows the
           in-cart ones on its cart events. The theme runs jQuery 1.x, whose
           .show() restores display to '' (not 'block'), so the style value
           cannot distinguish shown from our own undo — the cart itself is the
           only reliable source. Any style mutation therefore just re-pins the
           block visible and schedules one /cart.js read, which updates the
           parent-in-cart state and fires the redirect on a false→true
           transition of a selected block. */
        var pending = null;
        function syncFromCart() {
            pending = null;
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
                var ids = (c.items || []).map(function (it) { return String(it.product_id); });
                blocks.forEach(function (b) {
                    var was = b.dataset.mcParentInCart;
                    var now = ids.indexOf(String(b.getAttribute('data-adev-pairs-with-products'))) !== -1 ? 'true' : 'false';
                    b.dataset.mcParentInCart = now;
                    if (was === 'false' && now === 'true' && b.dataset.mcBacksideSelected === 'true') {
                        goToBackside(b);
                        return;
                    }
                    if (now === 'true') {
                        hideNote(b);
                        b.classList.remove('mc-pwp-selected');
                        b.dataset.mcBacksideSelected = 'false';
                    }
                });
            }).catch(function () {});
        }
        var mo = new MutationObserver(function () {
            blocks.forEach(function (b) { if (b.style.display) b.style.display = ''; });
            if (!pending) pending = setTimeout(syncFromCart, 80);
        });
        blocks.forEach(function (b) {
            mo.observe(b, { attributes: true, attributeFilter: ['style'] });
        });

        /* Capture phase: runs before the jQuery (bubble) handlers in
           adev-pairs-with-products.min.js and before link navigation. */
        document.addEventListener('click', function (e) {
            if (!e.target.closest) return;
            var block = e.target.closest('[data-mc-pwp-pdp]');
            if (!block || block.dataset.mcParentInCart !== 'false') return;
            if (!e.target.closest('.adev-pwp__item')) return;
            e.preventDefault();
            e.stopPropagation();
            setSelected(block, block.dataset.mcBacksideSelected !== 'true');
        }, true);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
